export * from './lib/FeatureProductTileMini';
